'use strict';

var ngModule = 'frontend.salary.invite';

require('angular')
  .module(ngModule, [])
  .component('salaryInvite', require('./salary-invite'))
  .component('salaryInviteImport', require('./salary-invite-import'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-invite/index.js
 ** module id = 193
 ** module chunks = 0
 **/